<div *ngIf="loaded">
    <app-calendar [eventSelected]="eventSelected"></app-calendar>
</div>